'use client';

import { motion } from 'framer-motion';

export const MotionNav = motion.nav;
